<template>
  <path
    d="M4 17.0002H20C20.55 17.0002 21 17.4502 21 18.0002C21 18.5502 20.55 19.0002 20 19.0002H4C3.45 19.0002 3 18.5502 3 18.0002C3 17.4502 3.45 17.0002 4 17.0002ZM4 10.0002H20C20.55 10.0002 21 10.4502 21 11.0002V14.0002C21 14.5502 20.55 15.0002 20 15.0002H4C3.45 15.0002 3 14.5502 3 14.0002V11.0002C3 10.4502 3.45 10.0002 4 10.0002ZM4 6.00018H20C20.55 6.00018 21 6.45018 21 7.00018C21 7.55018 20.55 8.00018 20 8.00018H4C3.45 8.00018 3 7.55018 3 7.00018C3 6.45018 3.45 6.00018 4 6.00018Z"
  />
</template>
